// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__354Nj","col":"styles_col__1Pix_"};